export const RATING_WINDOWS = [
  { level: 1, floor: 400, ceil: 799 },
  { level: 2, floor: 800, ceil: 1199 },
  { level: 3, floor: 1200, ceil: 1499 },
  { level: 4, floor: 1500, ceil: 1699 },
  { level: 5, floor: 1700, ceil: 1799 },
  { level: 6, floor: 1800, ceil: 1899 },
  { level: 7, floor: 1900, ceil: 1999 },
  { level: 8, floor: 2000, ceil: 2099 },
  { level: 9, floor: 2100, ceil: 2199 },
  { level: 10, floor: 2200, ceil: 2499 },
  { level: 11, floor: 2500, ceil: 3000 } // Master
];
export const LS_KEY = 'twinkle-chess-last-level';
